import { render, staticRenderFns } from "./signingAuthority.vue?vue&type=template&id=2c8d9d9b&scoped=true&"
import script from "./signingAuthority.vue?vue&type=script&lang=js&"
export * from "./signingAuthority.vue?vue&type=script&lang=js&"
import style0 from "./signingAuthority.vue?vue&type=style&index=0&id=2c8d9d9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d9d9b",
  null
  
)

export default component.exports